module.exports = __webpack_public_path__ + "img/Niehaus@2x.3b42d819.png";